module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/nina-torstensson-3b6fa46aed682261ab871dbe5bd073f8.jpg";